import React, { useState } from 'react';

interface FeedbackModalProps {
  onClose: () => void;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ onClose }) => {
  const [feedback, setFeedback] = useState('');

  const handleSubmit = () => {
    // In a real application, this would send the feedback to a support email address
    // using an email template managed in EmailTemplateStudio.
    console.log('Feedback submitted:', feedback);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm animate-in fade-in duration-300" onClick={onClose}></div>
      <div className="relative bg-white rounded-3xl shadow-2xl w-full max-w-lg overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="flex justify-between items-center p-8 border-b border-slate-100">
          <h2 className="text-xl font-black text-slate-900 tracking-tight">Send Feedback</h2>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-all">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <div className="p-10">
          <div className="space-y-4">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block">How can we improve?</label>
            <textarea 
              value={feedback}
              onChange={e => setFeedback(e.target.value)}
              className="w-full bg-slate-50 border border-slate-100 rounded-2xl px-6 py-4 text-xs font-bold text-slate-700 outline-none focus:ring-4 focus:ring-indigo-50 resize-none min-h-[150px]"
              placeholder="Share your suggestions or report an issue..."
            />
            <p className="text-[10px] text-slate-400 font-bold">Your feedback will be formatted and sent to our support team.</p>
          </div>
        </div>

        <div className="bg-slate-50 p-8 flex justify-end gap-3 border-t border-slate-100">
          <button onClick={onClose} className="px-6 py-2 text-xs font-black text-slate-400 uppercase tracking-widest hover:text-slate-900 transition-colors">Cancel</button>
          <button onClick={handleSubmit} className="px-8 py-3 bg-indigo-600 text-white rounded-2xl text-xs font-black uppercase tracking-widest hover:bg-indigo-700 shadow-xl shadow-indigo-100 transition-all active:scale-95">Submit Feedback</button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
